import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { always, ifElse, includes, isEmpty, pathSatisfies, pipe, when } from 'ramda';

import { Image, Video } from './mediaCover.styles';

export class MediaCover extends PureComponent {
  static propTypes = {
    media: PropTypes.object,
    poster: PropTypes.object,
  };

  renderImage = ({ file }) => (
    <Image disableRatioCalculation sizes={[320, 768, 1280, 1920]} imgProps={{ sizes: '100vw' }} file={file} />
  );

  renderVideo = ({ file }) => (
    <Video
      autoPlay
      muted
      loop
      playsInline
      file={file}
      controls={false}
      poster={this.props.poster}
      posterProps={{ sizes: [320, 768, 1280, 1920], imgProps: { sizes: '100vw' }, disableRatioCalculation: true }}
    />
  );

  renderMedia = pipe(
    when(isEmpty, always({ file: { contentType: 'placeholder' } })),
    ifElse(pathSatisfies(includes('video'), ['file', 'contentType']), this.renderVideo, this.renderImage)
  );

  render() {
    return this.renderMedia(this.props.media);
  }
}
